exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nspan.text-info {\n\tmargin-bottom: 15px;\n\tdisplay: inline-block;\n\tfont-family: 'Archivo', sans-serif;\n\tfont-size: 0.85rem;\n\tcolor: #1f2021;\n}\n", ""]);

// exports
